import React from "react";
import ReactDOM from "react-dom";
import PropTypes from "prop-types";
import {
  ExitIcon,
  ModalBG,
  ModalContainer,
  Title,
  Content,
  Footer
} from "./styles";

const modalRoot = document.getElementById("modal-root");

export default class PopupModal extends React.Component {
  el = document.createElement("div");

  componentDidMount() {
    modalRoot.appendChild(this.el);
  }

  componentWillUnmount() {
    modalRoot.removeChild(this.el);
  }

  render() {
    const { children, footer, onClose, title } = this.props;

    return ReactDOM.createPortal(
      <ModalBG onClick={onClose}>
        <ModalContainer onClick={e => e.stopPropagation()} hasFooter={!!footer}>
          <ExitIcon onClick={onClose} />
          {title && <Title>{title}</Title>}
          <Content>{children}</Content>
          {footer && <Footer>{footer}</Footer>}
        </ModalContainer>
      </ModalBG>,
      this.el
    );
  }
}

PopupModal.propTypes = {
  children: PropTypes.node,
  footer: PropTypes.node,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string
};
